export default "__VITE_ASSET__CEmcHj5S__"